import React, { useState, useEffect } from 'react';
import api from '../api';

let cachedMyRules = null;
let rulesPromise = null;

export const fetchMyUIRules = async () => {
  if (cachedMyRules) return cachedMyRules;
  if (!rulesPromise) {
    rulesPromise = api.get('/university/ui-config/me')
      .then(res => {
        cachedMyRules = res.data?.rules || {};
        return cachedMyRules;
      })
      .catch(err => {
        console.error("Failed to fetch user UI config rules", err);
        return {};
      })
      .finally(() => {
        rulesPromise = null;
      });
  }
  return rulesPromise;
};

export const clearUIRulesCache = () => {
  cachedMyRules = null;
  rulesPromise = null;
};

export function UIElementGuard({ page, element, children, fallback = null }) {
  const [accessLevel, setAccessLevel] = useState('FULL');

  useEffect(() => {
    fetchMyUIRules().then(rulesMap => {
      const key = `${page}:${element}`;
      if (rulesMap[key]) {
        setAccessLevel(rulesMap[key]);
      } else {
        setAccessLevel('FULL');
      }
    });
  }, [page, element]);

  if (accessLevel === 'HIDDEN') {
    return fallback;
  }

  if (accessLevel === 'READONLY') {
    return (
      <div
        style={{
          display: 'inline-block',
          opacity: 0.5,
          pointerEvents: 'none',
          userSelect: 'none',
          position: 'relative'
        }}
        title="Read-only: You don't have permission to perform this action"
        aria-disabled="true"
      >
        {React.Children.map(children, child => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              disabled: true,
              tabIndex: -1,
              'aria-disabled': true,
              onClick: undefined,
              onChange: undefined,
            });
          }
          return child;
        })}
      </div>
    );
  }

  return children;
}

export default UIElementGuard;
